import { modals } from 'js/src/data/modals/modals-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/modals/modals-actions';
export * from 'js/src/data/modals/modals-selectors';
export * from 'js/src/data/modals/modals-types';

export default modals;
